import {EmailModel} from "../../../core/sharedmodels/email/EmailModel";
import {Localizer} from "../../../infrastructure/localization/localizer";
import {dateTimeStringFromApiToDate} from "../../../index";
import {TextEditor} from "../../../core/components/textEditor/textEditor";
import {FileMetadataList} from "../../../core/components/fileMetadata/fileMetadataList";
import {FileLocationEnum} from "../../../core/sharedmodels/file/fileLocationEnum";

type EmailInfoProps = {
    email: EmailModel;
}
export const EmailInfo = ({email}: EmailInfoProps) => {
    return <div className="flex-container">
        <div
            className="flex-container-row flex-align-b border-bottom padding-bottom-m margin-bottom-m left-right-minus-spacing">
            <div className="flex-container-column">
                <p className="font-weight-bolder margin-0">{Localizer.createMail_SendBy() + " " + email?.fromName}</p>
                {email.sentAt
                    ?
                    <p className="margin-0">{dateTimeStringFromApiToDate(email.sentAt?.toString()).dateWithTimeFormat()}</p>
                    :
                    <p className="margin-0">{Localizer.global_noSentDate()}</p>
                }
                <p>{Localizer.global_subject() + ":"} {email.subject}</p>
            </div>
        </div>
        <div className="flex-container-row flex-align-b border-bottom padding-bottom-m margin-bottom-m left-right-minus-spacing">
            <TextEditor markdown={email.body} isViewer={true} id={email.id}/>
        </div>

        {email.fileMetadata.length > 0 &&
            <>
                <p className={"font-weight-bolder margin-top-s"}>{Localizer.FileAttachments()} ({email.fileMetadata.length})</p>
                <FileMetadataList fileMetadatas={email.fileMetadata}
                                  withUploader={false}
                                  fileLocation={FileLocationEnum.Email}
                />
            </>
        }
    </div>
}
